import * as React from 'react';

import { createIcon } from '../Icon';
export const BriefcaseIcon = createIcon(
  <React.Fragment>
    <rect height={14} rx={2} ry={2} width={20} x={2} y={7} />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </React.Fragment>,
  'BriefcaseIcon'
);
